export default [
  // Safe to ignore: https://forum.sentry.io/t/resizeobserver-loop-limit-exceeded/8402
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications.',
  // Safe to ignore: seems to be related to connectivity issues, because jQuery is loaded as soon as possible
  '$ is not defined',
  "'$' is not defined",
  "'$' is undefined",
  'hbspt is not defined',
  'HubstaffAuth is not defined',
  "'HubstaffAuth' is not defined",
  "'HubstaffAuth' is undefined",
  'window.TimeUtils is undefined',
  "'widgetInitializers' is undefined",
  "Can't find variable: widgetInitializers",
  "Can't find variable: $",
  "Can't find variable: HubstaffAuth",
  "Can't find variable: instantSearchSDKJSBridgeClearHighlight",
  'Unexpected token',
  'Unexpected string',
  'Invalid or unexpected token',
  'widgetInitializers is not defined',
  'SecurityError: Blocked a frame with origin',
  "Cannot set property 'UserTimeFormats' of undefined",
  "Cannot set properties of undefined (setting 'UserTimeFormats')",
  "Unable to set property 'UserTimeFormats' of undefined or null reference",
  'Cannot read properties of null',
  'undefined is not an object',
  'Unable to fetch tasks_ranking for insights',
  'Unable to fetch productivity_summary for insights',
  'Unable to fetch activity_summary for insights',
  'Unable to fetch achievements_summary for insights',
  'Unable to fetch time_worked_summary for insights',
  // Safe to ignore: most likely language related charset issues that won't affect functionality
  'illegal character U+009E',
];
